import React from "react";
import ApproveBookingItem from "components/Admin/Calendar/ApproveBooking/ApproveBookingItem";
import TablePagination from "components/Pagination/TablePagination";
import Headers from "./Headers";
import DateTimeField from "components/InputField/DateTimeField";
import UserTypeSelectCalendar from "containers/Calendar/UserTypeSelectCalendar";
import SelectField from "components/InputField/SelectField";
import DateRangeField from "components/InputField/DateRangeField";
import moment from "moment";

const labels = {
  start_date: "Start date",
  end_date: "End date",
};
const bookingTypes = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "pending", label: "Pending" },
];

export const ApproveBookingList = ({
  bookings = [],
  checkedUserIds,
  booking_type,
  paginationProps,
  onOrderChange,
  query,
  onBookingApprove,
  onBookingReject,
  onDateRangeChange,
  filter,
  onUserTypeChangeCalendar,
  isSponsor,
  changeFilterQuery,
  user_ids,
  deleteBookings,
}) => (
  <div>
    <div className="row">
      {!isSponsor ? (
        <p>
          <DateRangeField
            onChange={onDateRangeChange}
            fromValue={query.start_date}
            toValue={query.end_date}
            fieldName={"period"}
            className="col s4.5 calendar_picker"
            labels={labels}
          />
          <UserTypeSelectCalendar
            className="col s12"
            onChange={onUserTypeChangeCalendar}
            value={query.user_types}
            // errors={errors.user_types}
          />
        </p>
      ) : (
        ""
      )}
      <a
        style={{ maxWidth: 80, marginLeft: "auto", display: "block" }}
        onClick={deleteBookings}
        className={"booking-reject"}
      >
        Delete
      </a>
    </div>

    <table>
      <Headers onChange={onOrderChange} value={query.order} />
      {bookings.map((booking) => (
        <ApproveBookingItem
          booking={booking}
          user_ids={user_ids}
          checkedUserIds={checkedUserIds}
          key={booking.id}
          booking_type={booking_type}
          onBookingApprove={onBookingApprove}
          onBookingReject={onBookingReject}
          isSponsor={isSponsor}
        />
      ))}
      <tr>
        <td colSpan="9">
          <TablePagination {...paginationProps} />
        </td>
      </tr>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Admin/Calendar/ApproveBooking/ApproveBookingList.jsx